import cx from 'classnames';
import React, { FunctionComponent, useState } from 'react';

type Props = {
    available?: boolean;
    suffix: string;
    title: string;
    children?: React.ReactNode;
    active?: boolean;
};

const MobileMenuSection: FunctionComponent<Props> = ({ available = true, children, suffix, title, active = false }) => {
    const [expanded, setExpanded] = useState(active);

    if (!available) {
        return null;
    }

    return (
        <div className={cx(['mobile-menu__section', { 'mobile-menu__section--expanded': expanded }])}>
            <button className={`mobile-menu__heading mobile-menu__heading--${suffix}`} onClick={() => setExpanded(!expanded)}>
                {title}
            </button>
            {expanded && children}
        </div>
    );
};

export default MobileMenuSection;
